<template>
  <div id="wrapper">
    <div id="sidebar-wrapper">
      <div class="top">
        <img
          class="logo"
          src="@/assets/img/logo/primary-light.svg"
          alt="Codium"
        />
      </div>

      <div class="middle">
        <ul class="nav">
          <router-link
            class="nav-item"
            tag="li"
            :to="{ name: 'home' }"
          >
            <a class="nav-link">
              <i class="fal fa-fw fa-home"></i>
              Home
            </a>
          </router-link>
          <li
            class="nav-item"
            v-if="$can('read financials')"
          >
            <a
              href="#collapseDashboards"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              class="nav-link collapsed"
            >
              <i class="fal fa-fw fa-tachometer"></i>
              Dashboards
            </a>

            <ul
              id="collapseDashboards"
              class="collapse"
            >
              <router-link
                tag="li"
                :to="{ name: 'dashboards.utilization' }"
              >
                <a class="nav-link">Utilization</a>
              </router-link>
              <router-link
                tag="li"
                :to="{ name: 'dashboards.financial' }"
              >
                <a class="nav-link">Financial</a>
              </router-link>
              <router-link
                tag="li"
                :to="{ name: 'dashboards.sales' }"
              >
                <a class="nav-link">Sales</a>
              </router-link>
            </ul>
          </li>
          <router-link
            v-if="$can('read leads')"
            tag="li"
            :to="{name: 'leads.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-lightbulb"></i> Leads</a>
          </router-link>
          <router-link
            v-if="$can('read opportunities')"
            tag="li"
            :to="{name: 'opportunities.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-lightbulb"></i> Opportunities</a>
          </router-link>
          <router-link
            tag="li"
            :to="{name: 'signoffs.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-lightbulb"></i> Sign-Offs</a>
          </router-link>
          <router-link
            tag="li"
            :to="{name: 'clients.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-building"></i> Clients</a>
          </router-link>
          <router-link
            tag="li"
            :to="{name: 'stacks.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-lightbulb"></i> Stacks</a>
          </router-link>
          <router-link
            tag="li"
            :to="{name: 'retainers.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-sync"></i> Retainers</a>
          </router-link>

          <li v-if="$can('read invoices') || $can('read financials')" class="nav-item">
            <a
              href="#collapseFinancials"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              class="nav-link collapsed"
            >
              <i class="fal fa-fw fa-coins"></i>
              Financial
            </a>
            <ul
              id="collapseFinancials"
              class="collapse"
            >
              <router-link
                v-if="$can('read invoices')"
                tag="li"
                class="nav-item"
                :to="{name: 'invoices.index', query: { type: '1' }}"
              >
                <a class="nav-link">Invoices</a>
              </router-link>
              <router-link
                v-if="$can('read invoices')"
                tag="li"
                class="nav-item"
                :to="{name: 'budgets.index'}"
              >
                <a class="nav-link">T&M</a>
              </router-link>
              <router-link
                v-if="$can('read financials')"
                tag="li"
                class="nav-item"
                :to="{name: 'financial-targets.index'}"
              >
                <a class="nav-link">Financial Targets</a>
              </router-link>
              <router-link
                v-if="$can('read financials')"
                tag="li"
                class="nav-item"
                :to="{name: 'forecast.index'}"
              >
                <a class="nav-link">Cashflow Forecast</a>
              </router-link>
            </ul>
          </li>
          <li class="nav-item">
            <a
              href="#collapseSupport"
              data-bs-toggle="collapse"
              role="button"
              :aria-expanded="expanded('support')"
              :class="['nav-link', expanded('support') ? '' : 'collapsed']"
            >
              <i class="fal fa-fw fa-ticket"></i>
              Support
            </a>

            <ul
              id="collapseSupport"
              class="collapse"
              :class="{ show: expanded('support') }"
            >
              <router-link
                  tag="li"
                  :to="{ name: 'dashboards.support' }"
              >
                <a class="nav-link">Dashboard</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'slas.index'}"
              >
                <a class="nav-link">SLAs</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'invoices.uninvoiced', query: { type: '2' }}"
              >
                <a class="nav-link">Uninvoiced Work</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{ name: 'support.project-dependencies' }"
              >
                <a class="nav-link">Project Dependencies</a>
              </router-link>
            </ul>
          </li>
          <li class="nav-item">
            <a
              href="#collapseProjects"
              data-bs-toggle="collapse"
              role="button"
              :aria-expanded="expanded('projects')"
              :class="['nav-link', expanded('projects') ? '' : 'collapsed']"
            >
              <i class="fal fa-fw fa-folder"></i>
              Projects
            </a>

            <ul
              id="collapseProjects"
              class="collapse"
              :class="{ show: expanded('projects') }"
            >
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'projects.index'}"
              >
                <a class="nav-link">Projects</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'projects.planner.index'}"
              >
                <a class="nav-link">Project Planner</a>
              </router-link>

              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'projects.project-statuses'}"
              >
                <a class="nav-link">Project Statuses</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'warranties.index'}"
              >
                <a class="nav-link">Warranties</a>
              </router-link>
              <router-link
                v-if="$can('read project calculations')"
                tag="li"
                class="nav-item"
                :to="{name: 'project-calculations.index'}"
              >
                <a class="nav-link">Project Calculations</a>
              </router-link>
            </ul>
          </li>
          <li class="nav-item">
            <a
              href="#collapseDevops"
              data-bs-toggle="collapse"
              role="button"
              :aria-expanded="devopsExpanded"
              :class="['nav-link', devopsExpanded ? '' : 'collapsed']"
            >
              <i class="fal fa-fw fa-code"></i>
              Dev Ops
            </a>
            <ul
              id="collapseDevops"
              class="collapse"
              :class="{ show: devopsExpanded }"
            >
              <router-link
                v-if="isAdmin"
                tag="li"
                class="nav-item"
                :to="{name: 'clusters.index'}"
              >
                <a class="nav-link">Clusters</a>
              </router-link>
              <router-link
                tag="li"
                class="nav-item"
                :to="{name: 'applications.index'}"
              >
                <a class="nav-link">Applications</a>
              </router-link>
            </ul>
          </li>

          <router-link
            tag="li"
            class="nav-item"
            :to="{name: 'users.index'}"
          >
            <a class="nav-link">
              <i class="fal fa-fw fa-users"></i> Users
            </a>
          </router-link>

          <router-link
            tag="li"
            class="nav-item"
            :to="{name: 'settings.index'}"
          >
            <a class="nav-link">
              <i class="fal fa-fw fa-cog"></i> Settings
            </a>
          </router-link>
          <router-link
            tag="li"
            :to="{name: 'ai.index'}"
            class="nav-item"
          >
            <a class="nav-link"><i class="fal fa-fw fa-robot"></i> AI Chat</a>
          </router-link>
        </ul>
      </div>
    </div>

    <div id="page-content-wrapper">
      <router-view />
    </div>

    <chat-window />
  </div>
</template>

<script>
import { user } from 'mixins'
import { mapState } from 'vuex'
import { startsWith } from 'lodash'
import 'bootstrap-5'
import app from '@/assets/sass/app.lazy.scss'
import ChatWindow from '../components/ai/ChatWindow'

export default {
  mixins: [user],

  components: {
    ChatWindow
  },

  created () {
    app.use()
  },

  beforeDestroy () {
    app.unuse()
  },

  computed: {
    ...mapState('user', ['authorized']),

    devopsExpanded () {
      return this.expanded('clusters') || this.expanded('applications')
    }
  },

  methods: {
    expanded (name) {
      return startsWith(this.$route.name, name)
    }
  }
}
</script>
